import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { RestErrorManager } from './errors/rest-error-manager';
// import { HttpInterceptorService } from './http-interceptor.service';
import { LocaleDataService } from './locale-data.service';
import { SecurityDataService } from './security-data.service';
import { EnvironmentDataService } from './environment-data.service';
import { RoutingDataService } from './routing-data.service';
import { RoutingGuardService } from './routing-guard.service';
import { AuthenticationVerifierService } from './authentication-verifier.service';
import { AuthorizationVerifierService } from './authorization-verifier.service';
import { CanvasLayoutDataService } from './canvas-layout-data.service';
import { PageLayoutDataService } from './page-layout-data.service';
import { CookiePolicyAcceptanceVerifierService } from './cookie-policy-acceptance-verifier.service';
import {CookieService} from 'ngx-cookie-service'
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { GlobalErrorHandler } from './errors/app-error-handler';

// AoT requires an exported function for factories
export function initConfig(environmentDataService: EnvironmentDataService) {
  return () => environmentDataService.load();
}

// AoT requires an exported function for factories
export function httpLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  providers: [
    // { 
    //   provide: HTTP_INTERCEPTORS, 
    //   useClass: HttpInterceptorService, 
    //   multi: true 
    // },
    CookieService,
    LocaleDataService,
    SecurityDataService,
    RoutingGuardService,
    CookiePolicyAcceptanceVerifierService,
    AuthenticationVerifierService,
    AuthorizationVerifierService,
    RestErrorManager,
    EnvironmentDataService,
    RoutingDataService,
    CanvasLayoutDataService, 
    PageLayoutDataService,

    {
      provide: APP_INITIALIZER,
      useFactory: initConfig, // AoT requires an exported function for factories
      deps: [EnvironmentDataService],
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true }},
    {
      provide: ErrorHandler, 
      useClass: GlobalErrorHandler
    }
  ]
})
export class AngularCommonModule { }
